import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

type Props = {
  classes: Object,
  className: string,
  status: "isNew" | "isBackOnMarket" | "isPriceReduced" | "hasOpenHouse",
  title: "",
};

const Tag = ({ classes, className, status, title }: Props) => (
  <div className={classNames(classes.root, classes[status], className)}>
    {title}
  </div>
);

export default withStyles((theme) => ({
  root: {
    display: "flex",
    fontSize: "12px",
    lineHeight: "14px",
    fontWeight: "600",
    color: theme.colors.white,
    backgroundColor: theme.colors.gray["900"],
    borderRadius: theme.globalBorderRadius,
    padding: "4px 8px",
  },
  isNew: {
    backgroundColor: theme.colors.pink["600"],
  },
  isBackOnMarket: {
    backgroundColor: theme.colors.green["500"],
  },
  isPriceReduced: {
    backgroundColor: theme.colors.pink["600"],
  },
  hasOpenHouse: {
    backgroundColor: theme.colors.green["500"],
  },
}))(Tag);
